package org.vreo.devicehub.features.core.domain

/**
 * Sealed interface representing different types of data errors.
 */
sealed interface DataError : Error {
    enum class Local : DataError {
        DISK_FULL,
        SERIALIZATION,
        FORMATTING,
        INVALID_ARGUMENT,
        INVALID_STATE,
        NOT_FOUND,
        UNKNOWN
    }

    enum class Remote : DataError {
        REQUEST_TIMEOUT,
        TOO_MANY_REQUESTS,
        NO_INTERNET,
        SERIALIZATION,
        INVALID_CREDENTIALS,
        INVALID_ARGUMENT,
        NOT_FOUND,
        USER_ALREADY_EXISTS,
        STORAGE_FULL,
        STORAGE_NOT_REACHABLE,
        RATE_LIMIT_EXCEEDED,
        SERVICE_UNAVAILABLE,
        USER_LOCKED,
        UNKNOWN
    }

    /**
     * Local to remote error mapping.
     *
     * @return DataError.Remote
     */
    fun toRemote(): Remote {
        return when (this) {
            is Local -> {
                when (this) {
                    Local.DISK_FULL -> Remote.STORAGE_FULL
                    Local.INVALID_ARGUMENT -> Remote.INVALID_ARGUMENT
                    Local.INVALID_STATE -> Remote.INVALID_ARGUMENT
                    Local.NOT_FOUND -> Remote.NOT_FOUND
                    Local.SERIALIZATION -> Remote.SERIALIZATION
                    Local.UNKNOWN -> Remote.UNKNOWN
                    Local.FORMATTING -> Remote.UNKNOWN
                }
            }

            is Remote -> {
                this
            }
        }
    }
}